<template>
  <div class="exam-profile-input">
    <div
      v-click-outside="clickOutside"
      class="form-container"
    >
      <div class="md-input-container search md-theme-default">
        <label class="search__label">{{ profileSelected ? 'ADICIONADO:' : 'ADICIONAR:' }}</label>
        <div class="search-container search__input-container">
          <img
            v-if="!profileSelected"
            src="/static/images/icon-search-small.svg"
            alt="busca"
            class="search-container__icon-search"
          >
          <input
            id="examProfileInput"
            v-model="profileName"
            type="text"
            name="input-search"
            placeholder="Digite o nome ou código do exame que deseja adicionar…"
            maxlength="500"
            :class="{'search__input--selected': profileSelected}"
            class="search__input"
            autocomplete="off"
            @focus="handleFocus()"
          >
          <div
            v-if="isLoading"
            class="exam-profile-input__loading"
          >
            <spinner class="small" />
          </div>

          <!-- Results list -->
          <div
            v-if="showOptions && !isLoading"
            class="exam-profile-input__options"
          >
            <div
              v-for="(examProfile, index) in filteredArray"
              :key="index"
              class="exam-profile-input__profile"
            >
              {{ examProfile.name }}

              <div>
                <span class="exam-profile-input__qtd">
                  {{ examProfile.profile_exams.length }}
                  {{ examProfile.profile_exams.length > 1 ? ' exames' : ' exame' }}
                </span>

                <button
                  class="btn-primary exam-profile-input__button"
                  @click="selectExamProfile(examProfile)"
                >
                  Adicionar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="exam-profile-input__tags">
      <div
        v-for="(item, index) in examProfileList"
        :key="index"
        class="exam-profile-input__tag"
      >
        {{ item.name }}
        <div
          class="exam-profile-input__tag-action"
          @click="handleRemoveProfile(item)"
        >
          <md-tooltip md-direction="top">
            Remover Perfil
          </md-tooltip>
          <img
            src="/static/images/icon-close-purple.svg"
            alt="remover"
            width="10"
            height="10"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import examProfileService from '@/api/examProfile'
import fuzzysort from 'fuzzysort'
import Spinner from '@/components/common/Spinner'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ExamProfileSelect',
  components: {
    Spinner
  },
  data: () => ({
    isLoading: false,
    showOptions: false,
    profileSelected: false,
    profileName: '',
    examProfiles: []
  }),
  computed: {
    ...mapGetters(['examProfileList']),
    filteredArray () {
      if (this.profileName && this.examProfiles) {
        if (this.profileName.length > 0) {
          let result = fuzzysort.go(this.profileName, this.examProfiles, {
            keys: ['name'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map((item) => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.examProfiles
      }
    }
  },
  methods: {
    ...mapActions(['examProfileListSet']),
    ...mapActions(['getExamDetails']),
    ...mapActions(['pushLoadingExam']),
    ...mapActions(['deleteOrderExamsById']),
    ...mapActions(['orderRemoveProfile']),
    ...mapActions(['clearExamList']),
    ...mapActions(['setProfileExam']),
    clickOutside () {
      this.showOptions = false
    },
    loadProfiles () {
      if (this.examProfiles && this.examProfiles.length === 0) {
        this.isLoading = true
        examProfileService
          .getExamProfiles()
          .then((res) => {
            this.examProfiles = res.data
            this.isLoading = false
          })
      }
    },
    handleFocus () {
      this.showOptions = true
      this.loadProfiles()
    },
    handleClear () {
      this.profileSelected = false
      this.profileName = ''
      this.clearExamList()
    },
    selectExamProfile (examProfile) {
      let exams = examProfile.profile_exams
      exams = this.checkExamDuplicity(exams)
      this.examProfileListSet(examProfile)
      this.profileSelected = true
      this.profileName = examProfile.name
      exams.forEach(exam => {
        this.pushLoadingExam(exam.id_exam)
        this.setProfileExam({id: exam.id_exam, material: exam.id_material})
      })
      this.showOptions = false
      this.profileName = ''
    },
    handleRemoveProfile (examProfile) {
      this.orderRemoveProfile(examProfile.id_profile)
      const examProfileList = this.examProfileList
      this.clearExamList()
      examProfileList
      if (examProfileList.length > 0) {
        examProfileList.forEach(examProfile => {
          this.selectExamProfile(examProfile)
        })
      }
    },
    checkExamDuplicity (exams) {
      if (this.examProfileList.length > 0) {
        this.examProfileList.forEach(examProfile => {
          examProfile.profile_exams.forEach(exam => {
            const id = exam.id_exam
            exams = exams.filter((obj) => {
              return obj.id_exam !== id
            })
          })
        })
      }
      return exams
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  }
}
</script>

<style lang="scss">
.exam-profile-input {
  position: relative;

  &__tags {
    display: flex;
  }

  &__tag {
    display: flex;
    padding: 5px 10px;
    font-size: 12px;
    color: #7f1a54;
    border: 1px solid #7f1a54;
    border-radius: 3px;
    margin-right: 15px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  &__tag-action {
    margin-left: 15px;
    cursor: pointer;
  }

  &__loading {
    position: absolute;
    right: 5px;
    top: 5px;
  }

  &__options {
    position: absolute;
    top: 39px;
    background-color: #fff;
    z-index: 1;
    box-shadow: 0 4px 5px 1px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 100%;
    max-height: 276px;
    overflow: auto;
    overflow-x: hidden;
  }
  &__profile {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 26px;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background-color: #ddd;
    }
  }

  &__qtd {
    color: #7A7A7A;
    font-size: 14px;
  }

  &__button {
    padding: 5px 28px;
    background: none;
    border: 2px solid #7f1a54;
    border-radius: 3px;
    height: 38px;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: .8px;
    margin-left: 16px;
    background-color: #fff;
    // color: #7f1a54;

    &:hover {
      color: #fff;
    }
  }

  .search-container {
    &__icon-close {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }
  .md-input-container.search {
    margin: 0 0 20px;
    padding: 0;
    min-height: 39px;
  }
  .md-input-container.search .search__label {
    position: relative;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    float: left;
    width: 105px;
    top: inherit;
    left: inherit;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 1.1px;
    color: #727272;
  }
  .md-input-container.search .search__input-container {
    position: relative;
    display: block;
    width: calc(100% - 105px);
  }
  .md-theme-default.md-input-container:after {
    display: none !important;
  }
  .search {
    &__input {
      padding: 0 35px 0 30px;
      height: 100%;
      font-size: 15px;
      border-bottom: 1px solid #9f9f9f;
      color: #303030;
      letter-spacing: -.2px;
      &--selected {
        padding-left: 15px !important;
      }
    }
  }
}
</style>
